import { UserRoleEnum as n, PrivilegeEnum as s } from "./schemas.js";
const d = (e) => e.privileges.includes(s.ReadAdmin), t = (e) => e.privileges.includes(s.WriteAdmin), m = (e) => e.privileges.includes(s.SplitTrafficSourceBySsp), c = [
  n.Admin,
  n.AdAdmin,
  n.Manager
], o = [n.Admin, n.AdAdmin], a = [
  n.Advert,
  n.Publisher,
  n.Exchange
], A = (e) => e.some((i) => c.includes(i)), l = (e) => e.some((i) => o.includes(i));
export {
  a as CLIENT_ROLES,
  c as IMPERSONATION_ROLES,
  A as canImpersonate,
  l as canImpersonateAnyone,
  m as canSplitTrafficSourceBySsp,
  d as hasAdminRead,
  t as hasAdminWrite
};
//# sourceMappingURL=privileges.js.map
